import { lazy } from 'react';
import Loadable from 'components/Loadable';

const EnterpriseReports = Loadable(lazy(() => import('./components/enterprise-reports/EnterpriseReports')));

export const enterpriseRoutes = {
  path: 'enterprise',
  children: [
    { index: true, element: <EnterpriseReports /> },
    { path: 'reports', element: <EnterpriseReports /> },
    { path: 'audit', element: <EnterpriseReports /> }
  ]
};

export default enterpriseRoutes;
